import { Link } from 'react-router-dom';
import LogoPNG from '../../assets/Logo 02.png';
import Teams from './teams';


export default function Footer() {
    return (
        <footer className="w-full bg-ink-900 text-ink-300">
            <Teams />
            <div className="container-narrow section py-12 md:py-16">

                <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">

                    {/* Brand */}
                    <div>
                        <img src={LogoPNG} alt="UrbanFyzio Logo" className="w-32 h-auto mb-5" />
                        <p className="text-sm leading-relaxed text-ink-400 max-w-xs">
                            Soukromá fyzioterapeutická ambulance ve Frýdku-Místku. Individuální péče pro
                            sportovce i běžnou populaci.
                        </p>
                    </div>

                    {/* Contact */}
                    <div>
                        <h2 className="text-sm uppercase tracking-wider font-semibold text-white mb-5">
                            Kontaktujte nás
                        </h2>
                        <ul className="space-y-3">
                            <li>
                                <a href="mailto:info@urbanfyzio.cz" className="inline-flex items-center gap-3 hover:text-white transition-colors">
                                    <span className="w-8 h-8 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center">
                                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                            <polyline points="22,6 12,13 2,6" />
                                        </svg>
                                    </span>
                                    <span className="font-semibold">info@urbanfyzio.cz</span>
                                </a>
                            </li>
                            <li>
                                <a href="tel:+420734312843" className="inline-flex items-center gap-3 hover:text-white transition-colors">
                                    <span className="w-8 h-8 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center">
                                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
                                        </svg>
                                    </span>
                                    <span>+420 734 312 843</span>
                                </a>
                            </li>
                            <li className="inline-flex items-center gap-3">
                                <span className="w-8 h-8 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center">
                                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                        <circle cx="12" cy="10" r="3" />
                                    </svg>
                                </span>
                                <span>Palackého 131, Frýdek-Místek</span>
                            </li>
                        </ul>
                    </div>

                    {/* Links */}
                    <div>
                        <h2 className="text-sm uppercase tracking-wider font-semibold text-white mb-5">
                            Navigace
                        </h2>
                        <ul className="space-y-3">
                            <li><Link className="hover:text-white transition-colors" to="/cenik">Ceník</Link></li>
                            <li><Link className="hover:text-white transition-colors" to="/o-mne">O mně</Link></li>
                            <li>
                                <a
                                    href="https://urbanfyzio.reservio.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-white transition-colors"
                                >
                                    Rezervace
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>

                <hr className="my-10 border-t border-white/10" />

                <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-ink-400">
                    <span>© {new Date().getFullYear()} UrbanFyzio. Všechna práva vyhrazena.</span>
                    <div className="flex items-center gap-4">
                        <Link to="/zasady-ochrany-osobnich-udaju" className="hover:text-white transition-colors">
                            Zásady ochrany osobních údajů
                        </Link>
                        <span className="text-ink-500">Fyzioterapie Frýdek-Místek</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
